import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { AbConfigIntegrador } from 'app/abstract/full-pages/integrador/config-integrador.abstract';

@Injectable({ providedIn: 'root' })
export class ConfigIntegradorService extends AbConfigIntegrador {

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public getTimeZones(config: string): Observable<any> {
    return this.get(`timezones/filter/${config}`);
  }

  public getConfigIntegrador(id: number): Observable<any> {
    return this.get(`admin/config_integrador/${id}`);
  }

  public getConfiguracaoMfa(): Observable<any> {
    return this.get(`admin/v1/integrador/mfa/config`);
  }

  public getTenantsDisponiveis(): Observable<any> {
    return this.get(`admin/v1/integrador/mfa/tenants`);
  }

  public saveConfiguracaoMfaContas(habilitarMFAIntegradores: boolean, habilitarMFAContas: boolean, contasAtivacaoMFA: number[]): Observable<any> {
    let mfaConfigRequest = {
      habilitarMFAIntegradores: habilitarMFAIntegradores,
      habilitarMFAContas: habilitarMFAContas,
      contasAtivacaoMFA: contasAtivacaoMFA,
    };

    return this.put(`admin/v1/integrador/mfa/config`, ``, mfaConfigRequest);
  }

  public atualizarMfa(integradorId: number, habilitar: boolean): Observable<any> {
    return this.put(`admin/v1/config-integrador/security/mfa`, integradorId, {
      habilitarMfa: habilitar
    });
  }

  public salvaCofigIntegrador(config: any) {
    return this.save(`admin/config_integrador/`, config);
  }


}
